import React from 'react'
import { SideBarLink } from './SideBarLink'
import MetisMenu from 'react-metismenu'
import 'react-metismenu/dist/react-metismenu-standart.min.css'
export class SideNavBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeLinkTo: '/#' }
  }
  componentDidMount() {
    this.setState({
      activeLinkTo: window.location.hash.replace(/^#/, ''),
    })
  }
  componentWillReceiveProps() {
    this.setState({
      activeLinkTo: window.location.hash.replace(/^#/, ''),
    })
  }

  render() {
    const { menu } = this.props
    return (
      <MetisMenu
        className="bg-dark"
        content={menu}
        ref="metisMenu"
        activeLinkFromLocation={true}
        activeLinkTo={this.state.activeLinkTo}
        LinkComponent={SideBarLink}
      />
    )
  }
}
